export enum TelemetryErrorTagEnum {
    UNKNOWN = '',
    ENDPOINT = 'Endpoint',
}
